import axiosService from "../services/axiosService";
const axios = axiosService.getInstance()
import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'
const config = process.env.VUE_APP_ui_api_url

export default {
  actions: {
    async StartConnectionToHub(context, data) {
      const connection = new HubConnectionBuilder()
      .withUrl(`${config}/device`, {
        accessTokenFactory: () => data.accessToken,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .configureLogging(LogLevel.Information)
      .build()

      await connection.start()
      .then(() => {console.log('Connected HUB')})
      .catch(async (err) => {
        return console.error('err ' + err)
      })

      connection.on("Command", (message) => {
        console.log(message)
        data.root.$emit('HubCommand', message)
        try{
          const jsonData = JSON.parse(message)
          console.log(jsonData)
          if(jsonData.length > 0){
            context.commit('updateDeviceMapState', jsonData)
            
            data.root.$emit('ReMountMapByHub')
          }
        }
        catch(e){
        }
      })

      connection.on("UpdateDeviceConnectedState", (message) => {
        try{
          console.log(message)
          const jsonData = JSON.parse(message)
          console.log(jsonData)
          if(Object.keys(jsonData).length == 0){
            context.commit('removeAllDeviceConnectedState', 0)
          }else{
            const result = Object.keys(jsonData).map((key) => [jsonData[key].Id]);
            console.log(result)
            context.commit('updateDeviceConnectedState', result)
          }
          /*Object.keys(jsonData).forEach(key => {
            if(jsonData[key].Code == 0){
              context.commit('addDeviceConnectedState', jsonData[key].Id)
            }else{
              context.commit('removeDeviceConnectedState', jsonData[key].Id)
            }
          })*/
        }
        catch(e){
        }
      })
      await connection.onclose(async e => {
      })
      context.commit('saveConnection', connection)
    }
  },
  state: {
    connection: null,
    deviceMapState: [],
    deviceConnectedState: []
  },
  mutations: {
    updateDeviceConnectedState(state, data){
      state.deviceConnectedState = data
    },
    removeAllDeviceConnectedState(state, data){
      state.deviceConnectedState = []
    },
    removeDeviceConnectedState(state, data){
      if(state.deviceConnectedState.indexOf(data) >= 0){
        state.deviceConnectedState.splice(state.deviceConnectedState.indexOf(data), 1)
      }
    },
    addDeviceConnectedState(state, data){
      if(state.deviceConnectedState.indexOf(data) < 0){
        state.deviceConnectedState.push(data)
      }
    },
    saveConnection(state, data){
      state.connection = data
    },
    updateDeviceMapState(state, data){
      data.forEach(element => {
        let indexMap = state.deviceMapState.findIndex(st => st.DeviceId == element.DeviceId)
        if(indexMap >= 0){
          state.deviceMapState[indexMap] = element
        }else{
          state.deviceMapState.push(element)
        }
      });
    },
  },
  getters: {
    getConnection(state){
      return state.connection
    },
    getDeviceConnectedState(state){
      return state.deviceConnectedState
    },
    getDeviceMapState(state){
      return state.deviceMapState
    }
  }
}